'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'caret-up';
var width = 320;
var height = 512;
var aliases = [];
var unicode = 'f0d8';
var svgPathData = 'M137.9 137.4c12.9-11.6 32.4-12.8 45.2 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9l-2.2 4.3c-5.7 9.5-16.1 15.5-27.4 15.5l-256 0-4.8-.3c-9.4-1.4-17.7-7-22.6-15.1l-2.2-4.3c-4.9-12-2.2-25.7 6.9-34.9l128-128zM71.1 272l178.8 0-89.4-89.4-89.4 89.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCaretUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;